import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import ChartHOC from './chart-hoc'

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Header = styled.header`
  width: 100%;
  margin-bottom: 20px;
`

const TitleWrapper = styled.div`
  margin: 0 40px;
  border-bottom: 1px solid #ddd;
  text-align: center;
`

const Title = styled.h1`
  font-family: Arvo;
  font-style: italic;
  font-size: 2.5em;
  text-transform: uppercase;
  color: #ff6384;
  text-shadow: -1px -1px black, 1px -1px black, 2px 2px black, 4px 4px 4px lightblue;
`

export default function App ({ formId }) {
  return (
    <Root>
      <Header>
        <TitleWrapper>
          <Title>Team quarterly health check</Title>
        </TitleWrapper>
      </Header>
      <ChartHOC formId={formId} />
    </Root>
  )
}

App.propTypes = {
  formId: PropTypes.string,
}
